import { Injectable } from '@angular/core';

declare var $: any, myapp_config: any, initApp: any, layouts: any;
@Injectable({
  providedIn: 'root'
})
export class SmartAdminConfigService {

  /**
   * Selector GỐC của các "hook" trong `myapp_config`.
   *
   * `app.bundle.js` khai chúng là CHUỖI (`navHooks: '#js-nav-menu'`), rồi mã
   * khởi động thay bằng đối tượng jQuery trỏ vào node có mặt LÚC ĐÓ.
   *
   * Ở SmartAdmin gốc điều đó vô hại vì mỗi lần chuyển trang là tải lại cả
   * trang. Trong app này thì không: `/workspace` là layout riêng, nên rời
   * workspace về một màn cũ là MemLayout và LeftPanel bị huỷ rồi dựng lại —
   * `#js-nav-menu` là node MỚI, còn `myapp_config.navHooks` vẫn ôm node cũ đã
   * rời khỏi DOM. `buildNavigation()` khi ấy dựng accordion cho một node chết:
   * menu vẫn hiện nhưng mất mũi tên xổ và bấm không bung menu con.
   *
   * Vì vậy phải giữ lại chuỗi gốc và GIẢI LẠI mỗi lần khởi động.
   */
  private readonly hookSelectors = {
    navHooks: 'navHooks',
    navFilterInput: 'navFilterInput',
    navAnchor: 'navAnchor',
    appDateHook: 'appDateHook',
    mythemeColorProfileID: 'mythemeColorProfileID',
  };

  /** Chuỗi selector chụp lại lần đầu, trước khi bị ghi đè bằng jQuery object. */
  private readonly selectorGoc: Record<string, string> = {};

  constructor() { }

  /**
   * Giải lại các hook, trỏ vào DOM ĐANG hiện hữu.
   *
   * Chụp chuỗi selector NGAY TRONG hàm này thay vì ở constructor: constructor
   * của service `providedIn: 'root'` có thể chạy trước khi `app.bundle.js` kịp
   * tạo `myapp_config`. Khi đó không chụp được gì, mà khối gán cũ trong
   * `activeJsMemComponent()` thì đã bỏ — `navHooks` sẽ mãi là chuỗi, và
   * `app.bundle.js` gọi `myapp_config.navHooks.menuSlider(...)` trên một chuỗi
   * là ném `TypeError`.
   *
   * Hàm này luôn chạy trong `ngAfterViewInit` của layout, lúc đó `myapp_config`
   * chắc chắn đã có, và ở lần chạy đầu các khoá vẫn còn là chuỗi.
   */
  private giaiLaiHook = () => {
    if (typeof myapp_config === 'undefined') return;

    Object.values(this.hookSelectors).forEach((k) => {
      if (typeof myapp_config[k] === 'string') this.selectorGoc[k] = myapp_config[k];

      const sel = this.selectorGoc[k];
      if (sel) myapp_config[k] = $(sel);
    });
  };

  /**
   * Hàm kích hoạt Js cho app
   */
  activeJsAppComponent = () => {

    const newConfig = {
      root_: $(myapp_config["root_"]), // used for core app reference
      root_logo: $(myapp_config["root_logo"]), // used for core app reference
    };

    Object.assign(myapp_config, newConfig);

    /* =========   Do not change order   ==========*/
    /**
    * detect desktop or mobile
    **/
    initApp.addDeviceType();

    /**
     * detect Webkit Browser
     **/
    initApp.detectBrowserType();

    /**
     * check for mobile view width and add class .mobile-view-activated
     **/
    initApp.mobileCheckActivation();

    // initApp.windowScrollEvents();
  }

  /**
   * Hàm kích hoạt Js cho mem
   */
  activeJsMemComponent = () => {

    this.giaiLaiHook();

    /* =========   Do not change order   ==========*/

    /**
     * Gỡ bộ bắt sự kiện `[data-action]` cũ TRƯỚC khi `domReadyMisc()` gắn cái mới.
     *
     * `domReadyMisc()` trong `assets/js/app.bundle.js` gắn theo lối uỷ quyền:
     *
     *     myapp_config.root_.on('click touchend', '[data-action]', …)
     *
     * `root_` là `$('body')` — sống suốt phiên, KHÔNG bị gỡ khi MemLayout bị huỷ.
     * Mà hàm này chạy lại mỗi lần MemLayout được dựng, nên đi Workspace rồi quay
     * lại một màn cũ là body có thêm một bộ bắt nữa.
     *
     * Hậu quả: mỗi cú bấm nút `data-action="toggle"` chạy N lần. N chẵn là lớp
     * CSS được thêm rồi gỡ ngay — nút xổ menu trái bấm không ra gì, trông như
     * hỏng. Bản gốc SmartAdmin không gặp lỗi này vì nó là trang tải lại toàn bộ,
     * `domReadyMisc()` chỉ chạy đúng một lần cho mỗi lần tải trang.
     *
     * `off()` với cùng bộ (sự kiện, selector) chỉ gỡ đúng các handler uỷ quyền
     * đó, không đụng tới handler gắn thẳng lên từng phần tử.
     */
    $('body').off('click touchend', '[data-action]');

    initApp.blendColor();

    /**
      * d. run DOM misc functions
    **/
    initApp.domReadyMisc();

    /**
     * e. run app forms class detectors [parentClass,focusClass,disabledClass]
    **/
    initApp.appForms('.input-group', 'has-length', 'has-disabled');

    /**
     * @author Cường
     * 24/11/2023
     * f. Khởi động tooltips
     */
    initApp.tooltips();

    /**
     * @author Cường
     * 24/11/2023
     * g. Khởi động popovers
     */
    initApp.popovers();

    // fix navigation on when init app
    this.fixedNavigation();
  }


  /**
   * Hàm kích hoạt Js cho left panel
   */
  activeJsLeftPanel = () => {

    /**
     * BẮT BUỘC giải lại trước khi dùng — xem `hookSelectors`.
     *
     * Riêng ở đây còn một lý do nữa: `ngAfterViewInit` của component CON chạy
     * TRƯỚC của component CHA. LeftPanel là con của MemLayout, nên hàm này luôn
     * chạy trước `activeJsMemComponent()` — không thể trông chờ bên kia đã giải
     * hook hộ.
     */
    this.giaiLaiHook();

    /**
    * b. build navigation
    **/
    initApp.buildNavigation(myapp_config.navHooks);

    /**
    * c. initialize nav filter
    **/
    initApp.listFilter(myapp_config.navHooks, myapp_config.navFilterInput, myapp_config.navAnchor);
  }

  /**
   * setting layout full giống kiểu của View Email
   */
  layoutComposed = () => {
    initApp.pushSettings("layout-composed", false);
  }

  fixedNavigation = (): void => {
    layouts.fixedNavigation('on');
  }
}
